<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-rating`]" width="1em" height="1em" v-bind="$attrs"><path d="M12 2L14.645 8.35942L21.5106 8.90983L16.2798 13.3906L17.8779 20.0902L12 16.5L6.12215 20.0902L7.72025 13.3906L2.48944 8.90983L9.35497 8.35942L12 2Z" stroke="#165DFF" stroke-width="1.66" stroke-linejoin="round"/><path d="M12.797 16.1588L12.0009 16.6185L11.2048 16.1588C10.1433 15.5459 10.1433 14.0138 11.2048 13.4009C11.6974 13.1165 12.3044 13.1165 12.797 13.4009C13.8585 14.0138 13.8585 15.5459 12.797 16.1588Z" stroke="#00BBD8" stroke-width="1.66" stroke-linecap="round" stroke-linejoin="round"/></svg>
</template>
<script>

export default {
  name: 'IconColorRating',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
